import { render } from "./FairLendingPage.vue?vue&type=template&id=10201620&scoped=true"
import script from "./FairLendingPage.vue?vue&type=script&lang=js"
export * from "./FairLendingPage.vue?vue&type=script&lang=js"

import "./FairLendingPage.vue?vue&type=style&index=0&id=10201620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10201620"]])

export default __exports__